export const VehicleModelMasterEndpoints = (builder) => ({

    getVehicleModelMasters: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/VehicleModel/VehicleModelMaster',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['VehicleModelMaster'],
    }),

    getVehicleModelById: builder.query({
        query: (id) => `/VehicleModel/get-vehicle-model/${id}`,
        providesTags: (result, error, id) => [{ type: 'VehicleModelMaster', id }],
    }),

    saveVehicleModel: builder.mutation({
        query: (data) => ({
            url: '/VehicleModel/SaveVehicleModelMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['VehicleModelMaster'],
    }),

    updateVehicleModel: builder.mutation({
        query: ({ id, data }) => ({
            url: `/VehicleModel/SaveVehicleModelMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'VehicleModelMaster', id },
            'VehicleModelMaster'
        ],
    }),

    deleteVehicleModel: builder.mutation({
        query: (id) => ({
            url: `/VehicleModel/delete-vehicle-model/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['VehicleModelMaster'],
    }),

    bulkDeleteVehicleModel: builder.mutation({
        query: (ids) => ({
            url: "/VehicleModel/bulk-delete-vehicle-model",
            method: "POST",
            body: { ids },
        }),
        invalidatesTags: ['VehicleModelMaster'],
    }),

});
